<template>
  <div class="modal-body attendees-step">
    <div
      v-show="errorMessage"
      class="registration-errors"
    >
      <div class="alert alert-danger">{{errorMessage}}</div>
    </div>

    <p
      v-if="conference.id === 5245 || conference.id === 5246 || conference.id === 5247"
      style="margin-top: 15px; margin-bottom: 15px;"
    >
      <strong>CPI is intended as a SCCAP Member Only Benefit.</strong>
      If you are not already a member, please join here:
      <a class="text-primary" href="https://sccap53.org/membership/join-sccap-renew-membership/" target="_blank" style="text-decoration: underline;">Join SCCAP</a>
      <br />Professional Memberships are $40. Student/Postdoc/Post Bac memberships are free!
    </p>

    <!-- Single Form -->
    <div
      v-if="attendeeForm"
      v-html="attendeeForm"
      ref="attendeeForm"
      id="attendeeForm"
      class="registration-form"
    ></div>

    <!-- Multiple Form -->
    <validation-observer
      v-if="attendees?.length > 1"
      ref="attendeesForm"
      id="attendeesForm"
      v-slot="{ invalid, valid, errors, handleSubmit, ...rest }"
    >
      <div class="customer-info-form">
        <form @submit.prevent="handleSubmit(submitMultipleForm)">
          <div
            v-if="settings.checkoutNote"
            class="multiple-registration-description"
            v-html="settings.checkoutNote"
          ></div>

          <div
            v-for="(item, index) in attendees"
            :key="`attendee-${index}`"
          >
            <h5>Ticket {{index+1}} ({{item.ticket_name}})</h5>

            <!-- first_name -->
            <validation-provider :vid="`attendees.${index}.first_name`" rules="required" v-slot="{errors}">
              <div class="form-group">
                <label :for="`attendees.${index}.first_name`" class="control-label text-input">First Name <span class="asteric">*</span></label>
                <input
                  :id="`attendees.${index}.first_name`"
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': errors && errors[0]}"
                  :name="`attendees.${index}.first_name`"
                  v-model="item.first_name"
                  maxlength="50"
                  required
                />
                <span v-if="errors && errors[0]" class="input-error text-danger">{{errors[0]}}</span>
              </div>
            </validation-provider>

            <!-- last_name -->
            <validation-provider :vid="`attendees.${index}.last_name`" rules="required" v-slot="{errors}">
              <div class="form-group">
                <label :for="`attendees.${index}.last_name`" class="control-label text-input">Last Name <span class="asteric">*</span></label>
                <input
                  :id="`attendees.${index}.last_name`"
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': errors && errors[0]}"
                  :name="`attendees[${index}].last_name`"
                  v-model="item.last_name"
                  maxlength="50"
                />
                <span v-if="errors && errors[0]" class="input-error text-danger">{{errors[0]}}</span>
              </div>
            </validation-provider>

            <!-- email -->
            <validation-provider :vid="`attendees.${index}.email`" rules="required" v-slot="{errors}">
              <div class="form-group">
                <label :for="`attendees.${index}.email`" class="control-label text-input">Email <span class="asteric">*</span></label>
                <input
                  :id="`attendees.${index}.email`"
                  type="email"
                  class="form-control"
                  :class="{'is-invalid': errors && errors[0]}"
                  :name="`attendees.${index}.email`"
                  v-model="item.email"
                  @blur="updateRegistrantMembershipDiscount(item)"
                  maxlength="250"
                />
                <span v-if="errors && errors[0]" class="input-error text-danger">{{errors[0]}}</span>
              </div>
            </validation-provider>

            <!-- email_confirmation -->
            <validation-provider :vid="`attendees.${index}.email_confirmation`" rules="required" v-slot="{errors}">
              <div class="form-group">
                <label :for="`attendees.${index}.email_confirmation`" class="control-label text-input">Email Confirmation <span class="asteric">*</span></label>
                <input
                  :id="`attendees.${index}.email_confirmation`"
                  type="email"
                  class="form-control"
                  :class="{'is-invalid': errors && errors[0]}"
                  :name="`attendees.${index}.email_confirmation`"
                  v-model="item.email_confirmation"
                  maxlength="250"
                />
                <span v-if="errors && errors[0]" class="input-error text-danger">{{errors[0]}}</span>
              </div>
            </validation-provider>

            <div
              class="addon-wrapper"
              v-for="(addon, addonIndex) in item.addons"
              :key="`attendees.${index}..addons.${addonIndex}`"
            >
              <validation-provider
                class="addon-status-wrapper"
                :vid="`attendees.${index}.addons.${addonIndex}.selected`"
                v-slot="{errors}"
              >
                <event-checkbox
                  :class="{'is-invalid': errors && errors[0]}"
                  :label="addon.title"
                  v-model="addon.selected"
                  @input="updateAddonStatus(addon, item.ticket_id)"
                ></event-checkbox>
                <span v-if="errors && errors[0]" class="input-error text-danger">{{errors[0]}}</span>
              </validation-provider>

              <validation-provider
                v-show="!addon.has_sessions"
                :vid="`attendees.${index}.addons.${addonIndex}.quantity`"
                v-slot="{errors}"
              >
                <select
                  :id="`attendees.${index}.addons.${addonIndex}.quantity`"
                  class="form-control"
                  :class="{'is-invalid': errors && errors[0]}"
                  v-model="addon.selected_quantity"
                  :disabled="!addon.selected"
                  @change="updateAddonQuantities(addon, item.ticket_id)"
                >
                  <option value="0">0</option>
                  <option
                    v-for="(option, optionIndex) in addon.available_quantity"
                    :key="`ticket-${item.ticket_id}-${item.index}-addons-${addon.id}-option-${optionIndex}`"
                    :value="option"
                  >{{ option }}</option>
                </select>
                <span v-if="errors && errors[0]" class="input-error text-danger">{{errors[0]}}</span>
              </validation-provider>
            </div>

            <br />
          </div>
        </form>
      </div>
    </validation-observer>

    <div v-if="conference.id === 7007">
      <h5>CANCELLATION/REFUND POLICY</h5>
      <p>
        A full refund minus a cancellation fee will be issued if cancelled in writing by September 1, 2025 (6% cancellation fee applies). A 50% refund will be issued if cancelled in writing by September 26, 2025. No refunds will be issued after September 26, 2025.
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import formValidation from "../../plugins/formvalidation/dist/es6/core/Core";
import Trigger from "../../plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "../../plugins/formvalidation/dist/es6/plugins/Bootstrap";
import { scrollToNotValidField } from "../../helpers/scrollToNotValidField";
//import { scrollToTop } from '../../helpers/scrollToTop'

export default {
  mounted() {
    if (document.getElementById('attendeeForm') && this.attendeeForm) {
      this.modifyAgreeCheckbox();
      this.hideParagraphAndHeaderLabels();
      this.initValidation();
      this.initOtherToggle('state', 'other_state', '.other-state-wrapper');
      this.initOtherToggle('discipline_id', 'discipline_other', '.other-discipline-wrapper');

      if (this.membershipDiscountEnabled) {
        this.initUpdateRegistrantMembershipDiscount();
      }

      this.initFieldsWithCouponsListeners();
    } else {
      if (this.attendees?.length) {
        this.attendees.forEach(attendee => {
          attendee.addons.forEach(addon => {
            if (addon.selected) {
              this.updateAddonQuantities(addon, attendee.ticket_id);
            }
          });
        });
      }
    }
  },
  computed: {
    ...mapGetters("basketStore", [
      "conference",
      "settings",
      "slug",
      "tickets",
      "attendeeForm",
      "attendeeValidation",
      "attendees",
      "errorMessage",
      "selectedSessionAddons",
      "selectedItemAddons",
      "membershipDiscountEnabled",
      "fieldsWithCoupons"
    ])
  },
  data() {
    return {
      formValidation: null
    }
  },
  methods: {
    ...mapActions('basketStore', [
      'fetchBasket',
      'fetchAttendees',
      'updateAttendees',
      'updateMembershipAttendeeDiscount',
      'updateAttendeeFieldCouponDiscount'
    ]),

    initOtherToggle(fieldName, otherFieldName, wrapperClass) {
      const root = '#attendeeForm';

      const getFieldSelect = () =>
        document.querySelector(`${root} select#${fieldName}`) ||
        document.querySelector(`${root} select[name="${fieldName}"]`);

      const getOtherFieldInput = () =>
        document.querySelector(`${root} #${otherFieldName}`) ||
        document.querySelector(`${root} input[name="${otherFieldName}"]`);

      const toggle = () => {
        const fieldSelect = getFieldSelect();
        const otherFieldInput = getOtherFieldInput();
        const otherFieldWrapper = document.querySelector(`${root} ${wrapperClass}`);

        if (!fieldSelect || !otherFieldInput) return;

        const shouldShow = String(fieldSelect.value) === '0';

        if (otherFieldWrapper) {
          otherFieldWrapper.classList.toggle('d-none', !shouldShow);
        } else {
          // fallback: if the wrapper is not applied — hide the input itself
          otherFieldInput.classList.toggle('d-none', !shouldShow);
        }

        // if we hide it — clear the value to avoid submitting unnecessary data
        if (!shouldShow) {
          otherFieldInput.value = '';
        }
      };

      // delegated, since the form is inserted via v-html
      $(document)
        .off(`change.${otherFieldName}`, `${root} select#${fieldName}, ${root} select[name="${fieldName}"]`)
        .on(`change.${otherFieldName}`, `${root} select#${fieldName}, ${root} select[name="${fieldName}"]`, toggle);

      // initialization of the state on first render
      toggle();
    },

    updateRegistrantMembershipDiscount(attendee) {
      if (this.membershipDiscountEnabled) {
        const requestData = {
          data: {
            id: attendee.id || null,
            email: attendee.email
          },
          success: () => {},
          error: (err) => {
            if (err?.flash) {
              this.errorMessage = err.flash;
            }
            if (err?.errors) {
              scrollToNotValidField(err.errors, '.modal-body.attendees-step');
            }
          }
        };

        this.updateMembershipAttendeeDiscount(requestData);
      }
    },

    initUpdateRegistrantMembershipDiscount() {
      const attendees = this.attendees;
      const updateMembershipAttendeeDiscount = this.updateMembershipAttendeeDiscount;
      let blurTimeout;
      let emailInput = document.querySelector('#attendeeForm input[name="email"]');

      emailInput.addEventListener('blur', () => {
        handleBlur();
      });

      function handleBlur() {
        if (blurTimeout) {
          clearTimeout(blurTimeout);
        }

        blurTimeout = setTimeout(() => {
          autoUpdateRegistrantDiscount();
        }, 100);
      }

      function autoUpdateRegistrantDiscount() {
        const emailInput = document.querySelector('#attendeeForm input[name="email"]');

        const requestData = {
          data: {
            id: attendees?.length ? attendees[0].id : null,
            email: emailInput.value
          },
          success: () => {},
          error: (err) => {
            if (err?.flash) {
              this.errorMessage = err.flash;
            }
            if (err?.errors) {
              scrollToNotValidField(err.errors, '.modal-body.attendees-step');
            }
          }
        };

        updateMembershipAttendeeDiscount(requestData);
      }
    },

    initFieldsWithCouponsListeners() {
      const fields = this.fieldsWithCoupons;

      if (!fields?.length) return;

      const root = '#attendeeForm';
      // Match both `name="field"` and `name="field[]"` (PHP checkbox group convention)
      const selector = fields.flatMap(name => [
        `${root} [name="${name}"]`,
        `${root} [name="${name}[]"]`
      ]).join(', ');
      let debounceTimeout;

      const handleChange = (event) => {
        const rawName = event.target?.name;
        // Strip trailing [] so "field[]" matches "field" in the fields list
        const name = rawName?.replace(/\[\]$/, '');

        if (!fields.includes(name)) return;

        if (debounceTimeout) clearTimeout(debounceTimeout);

        debounceTimeout = setTimeout(() => {
          this.updateFieldCouponDiscount(name);
        }, 100);
      };

      $(document)
        .off('change.fields_with_coupons', selector)
        .on('change.fields_with_coupons', selector, handleChange);
    },

    collectFieldValue(name) {
      const form = document.getElementById('attendeeForm');

      if (!form) return null;

      // Try plain name first, then PHP array notation (field[])
      let elements = form.querySelectorAll(`[name="${name}"]`);
      if (!elements.length) {
        elements = form.querySelectorAll(`[name="${name}[]"]`);
      }

      if (!elements.length) return null;

      const first = elements[0];

      // radio group: return the checked value
      if (first.type === 'radio') {
        const checked = Array.from(elements).find(el => el.checked);
        return checked?.value ?? null;
      }

      // checkbox group: return array of checked values; single checkbox returns boolean
      if (first.type === 'checkbox') {
        if (elements.length > 1) {
          return Array.from(elements).filter(el => el.checked).map(el => el.value);
        }
        return first.checked;
      }

      // multi-select: return array of all selected values
      if (first.tagName === 'SELECT' && first.multiple) {
        return Array.from(first.options).filter(o => o.selected).map(o => o.value);
      }

      // single select and text inputs
      return first.value;
    },

    updateFieldCouponDiscount(name) {
      const requestData = {
        data: {
          id: this.attendees?.length ? this.attendees[0].id : null,
          field_name: name,
          field_value: this.collectFieldValue(name)
        },
        success: () => {},
        error: (err) => {
          if (err?.flash) {
            this.errorMessage = err.flash;
          }
          if (err?.errors) {
            scrollToNotValidField(err.errors, '.modal-body.attendees-step');
          }
        }
      };

      this.updateAttendeeFieldCouponDiscount(requestData);
    },

    updateAddonStatus(currentAddon, currentTicketId) {
      if (currentAddon.has_sessions) {
        // Count every selected session add-on across all attendees, not just the
        // toggled id — otherwise the "Session Add-on left" counter would reflect
        // only the last-toggled add-on when several session add-ons exist.
        let selectedSessionAddonsQuantity = 0;

        this.attendees.forEach(attendee => {
          attendee.addons.forEach(addon => {
            if (addon.selected && addon.has_sessions) {
              selectedSessionAddonsQuantity += 1;
            }
          });
        });
        this.$store.commit('basketStore/updateSelectedSessionAddons', selectedSessionAddonsQuantity);

        // Session addons have no quantity <select>; drive selected_quantity off the checkbox
        // so the multi-attendee validator (sum of selected_quantity === purchased qty) passes.
        currentAddon.selected_quantity = currentAddon.selected ? currentAddon.available_quantity : 0;
      }

      if (!currentAddon.has_sessions) {
        if (!currentAddon.selected) {
          currentAddon.selected_quantity = 0;
        }

        this.updateAddonQuantities(currentAddon, currentTicketId);
      }
    },

    updateAddonQuantities(currentAddon, currentTicketId) {
      let selectedCurrentAddonsQuantity = 0;
      let selectedTotalAddonsQuantity = 0;
      const currentAddonId = currentAddon.id;

      this.attendees.forEach(attendee => {
        attendee.addons.forEach(addon => {
          //addon.id === currentAddonId
          // Item counter must exclude session add-ons (they now carry a
          // selected_quantity); session add-ons are tracked separately via
          // updateSelectedSessionAddons.
          if (addon.selected && !addon.has_sessions) {
            selectedTotalAddonsQuantity += +addon.selected_quantity;
          }
          if (addon.id === currentAddonId && attendee.ticket_id === currentTicketId) {
            selectedCurrentAddonsQuantity += +addon.selected_quantity;
          }
        });
      });

      this.$store.commit('basketStore/updateSelectedItemAddons', selectedTotalAddonsQuantity);

      this.attendees.forEach(attendee => {
        attendee.addons.forEach(addon => {
          if (addon.id === currentAddonId && attendee.ticket_id === currentTicketId) {
            const availableQuantity = +addon.quantity - +selectedCurrentAddonsQuantity;
            addon.available_quantity = +addon.selected_quantity + +availableQuantity;
          }
        });
      });
    },

    modifyAgreeCheckbox() {
      const privacyLink = `/${this.slug}/policies`;

      $('label[for=\'agree[]\']').hide();
      $('label[for=\'agree\']').hide();
      $('label[for=\'receive_updates\']').hide();

      const agreeLabel = `I agree with the <a href="${privacyLink}" target="_blank">terms and conditions</a> of this site`;
      $('label[for=\'agree_agree\']').html(agreeLabel);
    },

    hideParagraphAndHeaderLabels() {
      const h1 = $('.registration-form h1.form-control-static');
      const h2 = $('.registration-form h2.form-control-static');
      const h3 = $('.registration-form h3.form-control-static');
      const h4 = $('.registration-form h4.form-control-static');
      const h5 = $('.registration-form h5.form-control-static');
      const h6 = $('.registration-form h6.form-control-static');
      const p = $('.registration-form p.form-control-static');
      const address = $('.registration-form address.form-control-static');
      const blockquote = $('.registration-form blockquote.form-control-static');
      const canvas = $('.registration-form canvas.form-control-static');
      const output = $('.registration-form output.form-control-static');

      if (h1.prev()) {
        h1.prev().hide();
      }
      if (h2.prev()) {
        h2.prev().hide();
      }
      if (h3.prev()) {
        h3.prev().hide();
      }
      if (h4.prev()) {
        h4.prev().hide();
      }
      if (h5.prev()) {
        h5.prev().hide();
      }
      if (h6.prev()) {
        h6.prev().hide();
      }

      if (p.prev()) {
        p.prev().hide();
      }
      if (address.prev()) {
        address.prev().hide();
      }
      if (blockquote.prev()) {
        blockquote.prev().hide();
      }
      if (canvas.prev()) {
        canvas.prev().hide();
      }
      if (output.prev()) {
        output.prev().hide();
      }
    },

    initValidation() {
      this.formValidation = formValidation(document.getElementById('attendeeForm'), {
        fields: {},
        plugins: {
          trigger: new Trigger(),
          bootstrap: new Bootstrap()
        }
      })

      for (const [key, value] of Object.entries(this.attendeeValidation)) {
        if (value.required) {
          this.formValidation.addField(`${key}`, {
            validators: {
              notEmpty: { message: `${value.label} is required` }
            }
          })
        }
      }
    },

    validateForm: async function() {
      return this.formValidation.validate().then(status => {
        return (this.validationStatus = status === 'Valid')
      })
    },

    resetForm() {
      // this.formValidation.resetForm()
    },

    submitForm: async function() {
      if (this.attendees?.length > 1) {
        this.$refs.attendeesForm.handleSubmit(this.submitMultipleForm);
      } else {
        // if (!(await this.validateForm())) {
        //   return;
        // }

        await this.submitSingleForm();
      }
    },

    submitSingleForm() {
      return new Promise(resolve => {
        let data = {}
        let form = document.querySelector('#attendeeForm form');

        if (form && form.elements && form.elements.length) {
          Array.from(form.elements).forEach(item => {
            if (item.type === 'radio') {
              if (item.checked) {
                data[item.name] = item.value
              }
            } else if (item.type === 'checkbox') {
              if (typeof data[item.name] === 'undefined') {
                data[item.name] = []
              }
              if (item.checked) {
                data[item.name].push(item.value)
              }
            } else if (item.type === 'select-multiple') {
              // <select multiple> renders as name="field[]"; item.value returns
              // only the first selected option, so collect every selected value.
              data[item.name] = Array.from(item.selectedOptions).map(o => o.value)
            } else {
              data[item.name] = item.value
            }
          })
        }

        const requestData = {
          attendees: [
            {
              ...data,
              id: this.attendees[0].id,
              ticket_id: this.attendees[0].ticket_id
            }
          ],
          success: () => {
            this.resetForm();
            this.$store.dispatch('basketStore/changeStep', { type: "forward" });
          },
          error: (err) => {
            if (err?.flash) {
              this.errorMessage = err.flash;
            }
            if (err?.errors) {
              // scrollToTop('.modal-body');
              scrollToNotValidField(err.errors, '.modal-body.attendees-step', true);
            }
          }
        };

        this.updateAttendees(requestData);
      })
    },

    submitMultipleForm: async function () {
      const data = {
        attendees: this.attendees,
        success: () => {
          this.$nextTick(() => {
            // this.$refs.attendeesForm.reset();
          });

          // go to next step
          this.$store.dispatch('basketStore/changeStep', { type: "forward" });
        },
        error: (err) => {
          if (err.errors) {
            this.$refs.attendeesForm.setErrors(err.errors);
            scrollToNotValidField(err.errors, '.modal-body.attendees-step');
          }
        }
      };

      this.$refs.attendeesForm.validate().then(success => {
        if (!success) {
          return
        }

        this.updateAttendees(data);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.form-group .control-label {
  font-weight: 400;
}

.addon-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
}

.addon-status-wrapper {
  margin-top: 10px;
}

:deep(.app-checkbox div) {
  font-weight: 400;
}

:deep(.fv-help-block) {
  font-family: sans-serif;
  font-weight: 700;
  color: #dc3545 !important;
  font-size: 16px;
}
</style>
